import products from "./../data/products/products";
export const addToCart = (id) => (dispatch, getState) => {
  const data = products.find((i) => i.id === id);

  dispatch({
    type: "CART_ADD_ITEM",
    payload: {
      product: data.id,
      title: data.title,
      desc: data.desc,
      price: data.price,
      image: data.image,
      text: data.text,
    },
  });
  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

export const removeCart = (id) => (dispatch, getState) => {
  dispatch({
    type: "CART_REMOVE_ITEM",
    payload: id,
  });
  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};
